import { Component } from '@theme/component';

export default class SizeUnitToggle extends Component {
  /** @type {NodeListOf<HTMLButtonElement>} */
  buttons;

  /** @type {NodeListOf<HTMLTableElement>} */
  tables;

  connectedCallback() {
    super.connectedCallback();
    this.buttons = /** @type {NodeListOf<HTMLButtonElement>} */ (this.querySelectorAll('button[data-unit]'));
    this.tables = /** @type {NodeListOf<HTMLTableElement>} */ (this.querySelectorAll('table[data-unit]'));

    this.addEventListener('click', this.handleClick.bind(this));
  }

  /** @param {Event} event */
  handleClick(event) {
    const button = /** @type {Element | null} */ (event.target)?.closest('button[data-unit]');
    if (!(button instanceof HTMLButtonElement)) return;

    const unit = button.dataset.unit;

    this.buttons.forEach((btn) => {
      const isActive = btn.dataset.unit === unit;
      btn.setAttribute('aria-pressed', String(isActive));
      btn.classList.toggle('size-guide__toggle-button--active', isActive);
    });

    this.tables.forEach((table) => {
      table.hidden = table.dataset.unit !== unit;
    });
  }
}

if (!customElements.get('size-unit-toggle')) {
  customElements.define('size-unit-toggle', SizeUnitToggle);
}
